/**
 * Navigation — PEFEP Site — v3
 * ---------------------------------------------------------------
 * Barre de navigation partagee par toutes les pages publiques.
 *
 * Le logo pointe vers le NOUVEAU logo PEFEP Site (dossier public/),
 * remplacant l'ancien assets/logo-complet.png qui affichait encore
 * "PEFEP TECH" et le faisait apparaitre sur toutes les pages.
 *
 * Les classes CSS (.navbar, .navbar-link...) sont deja definies
 * dans PageContact.css et s'appliquent partout.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const LOGO_PEFEP_SITE = process.env.PUBLIC_URL + '/logo-pefep-site-blanc.png';

function Navigation() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  function allerEspace() {
    navigate(user ? '/tableau-de-bord' : '/connexion');
  }

  function rendreActions() {
    if (user) {
      return [
        <button
          type="button"
          className="navbar-user navbar-user-btn"
          key="profil"
          onClick={allerEspace}
        >
          👤 {user.prenom || user.nom}
        </button>,
        <button
          type="button"
          className="navbar-btn-primary"
          key="espace"
          onClick={allerEspace}
        >
          Mon espace
        </button>,
        <button
          type="button"
          className="navbar-btn-outline"
          key="deconnexion"
          onClick={logout}
        >
          Déconnexion
        </button>,
      ];
    }

    return [
      <button
        type="button"
        className="navbar-btn-outline"
        key="connexion"
        onClick={function () {
          navigate('/connexion');
        }}
      >
        Connexion
      </button>,
      <button
        type="button"
        className="navbar-btn-primary"
        key="commencer"
        onClick={function () {
          navigate('/connexion');
        }}
      >
        Commencer
      </button>,
    ];
  }

  const liens = [
    { libelle: 'À propos', chemin: '/qui-sommes-nous' },
    { libelle: 'Tarifs', chemin: '/tarifs' },
    { libelle: 'Domaines', chemin: '/domaines' },
    { libelle: 'FAQ', chemin: '/faq' },
    { libelle: 'Contact', chemin: '/contact' },
  ];

  return (
    <nav className="navbar">
      <img
        src={LOGO_PEFEP_SITE}
        alt="PEFEP Site"
        className="navbar-logo"
        onClick={function () {
          navigate('/');
        }}
        style={{ cursor: 'pointer' }}
      />
      <div className="navbar-links">
        {liens.map(function (lien) {
          return (
            <button
              type="button"
              className="navbar-link"
              key={lien.chemin}
              onClick={function () {
                navigate(lien.chemin);
              }}
            >
              {lien.libelle}
            </button>
          );
        })}
        {rendreActions()}
      </div>
    </nav>
  );
}

export default Navigation;